export interface IValueForCalculateExtractable {
  // 経過時間の結果が「**分」といった文字列になっていて計算できないので暫定対策
  extractValueForCalculate(): any;
}

export function instanceOfIValueForCalculateExtractable(instance: any): instance is IValueForCalculateExtractable {
  if (!instance) { return false; }
  return (instance.extractValueForCalculate !== undefined);
}
